<span class="fragment">
  <h3 *ngIf="showTitle && (title$ | async)" class="teaser-title">
    {{ title$ | async }}
  </h3>
  <div *ngIf="icon$ | async" class="teaser-icon-container">
    <img [src]="icon$ | async" [alt]="title$ | async | finEmpty" class="grow" />
  </div>
  <div class="teaser-text" [innerHTML]="text$ | async | resolveLinks | finSafe: 'html'"></div>
</span>
